import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { toast } from "sonner";
import Logo from "@/components/Logo";
import ConsentCheckbox from "@/components/ConsentCheckbox";
import { LegalBody } from "@/pages/Legal";

export default function ConsentGate() {
  const { user, setUser, logout } = useAuth();
  const nav = useNavigate();
  const [checked, setChecked] = useState(false);
  const [tab, setTab] = useState("terms");
  const [busy, setBusy] = useState(false);

  const accept = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/auth/accept-terms");
      setUser(data);
      toast.success("Thank you — terms accepted");
    } catch { toast.error("Could not record acceptance"); }
    finally { setBusy(false); }
  };

  return (
    <div data-testid="consent-gate" className="fixed inset-0 z-50 bg-[#0A2A5E]/80 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="w-full max-w-3xl bg-white rounded-2xl shadow-2xl flex flex-col max-h-[92vh]">
        <div className="p-6 border-b border-slate-200 flex items-center gap-3">
          <Logo size={40} />
          <div>
            <h1 className="font-display text-xl font-bold text-[#0A2A5E]">Before you continue, {user?.name?.split(" ")[0]}</h1>
            <p className="text-sm text-slate-600">Please review and accept the current Terms of Service and Privacy Policy. This step cannot be skipped.</p>
          </div>
        </div>
        <div className="px-6 pt-4">
          <Tabs value={tab} onValueChange={setTab}>
            <TabsList><TabsTrigger value="terms" data-testid="gate-tab-terms">Terms of Service</TabsTrigger><TabsTrigger value="privacy" data-testid="gate-tab-privacy">Privacy Policy</TabsTrigger></TabsList>
          </Tabs>
        </div>
        <ScrollArea className="flex-1 px-6 py-4 max-h-[42vh]">
          <LegalBody kind={tab} />
        </ScrollArea>
        <div className="p-6 border-t border-slate-200 space-y-3">
          <ConsentCheckbox checked={checked} onChange={setChecked} testid="gate-terms-checkbox" />
          <div className="flex justify-between gap-2">
            <Button variant="ghost" data-testid="gate-decline-btn" onClick={() => { logout(); nav("/"); }} className="text-slate-600">Decline & sign out</Button>
            <Button data-testid="gate-accept-btn" disabled={!checked || busy} onClick={accept} className="bg-[#0A2A5E] hover:bg-[#0F3F8A] text-white">{busy ? "Saving…" : "I agree — continue"}</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
